import React from 'react';
import styled from 'styled-components/native';
import PromptList from '../../components/PromptList';
import { log } from '../../tools/LogHelper';
import { stringify } from 'flatted';

const StyledContainer = styled.View`
  flex: 1;
  background-color: white;
  align-items: center;
  justify-content: center;
`;

const PromptListExampleScreen: React.FC = () => {
  return (
    <StyledContainer>
      <PromptList
        promptData={[
          {
            id: 1,
            title: '5 coins',
            message: 'Do you take a daily multivitamin?',
            buttonLabels: ['Yes', 'No']
          },
          {
            id: 2,
            titleIconUrl:
              'https://i.picsum.photos/id/791/536/354.jpg?hmac=eXUPs7QLTn9HF78YkhAz85vtEsUXj2aePprZoTCwCdU',
            title: '10 coins',
            message: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.`,
            buttonLabels: ['Yes', 'Maybe', 'No']
          }
        ]}
        onSelect={(prompt, buttonLabel) => {
          log(`${buttonLabel}`, stringify(prompt));
        }}
      />
    </StyledContainer>
  );
};

export default PromptListExampleScreen;
